// Written by desktop/scripts/stamp-version.js. Do not edit by hand.
export const VERSION = "0.9.250";
export const BUILT_AT = "5 nov 18:23";
export const BUILT_AT_ISO = "2026-11-05T17:23:38.375Z";
